import { LOAD_FACILITIES_SUCCESS } from '../actions/facilityActions';

import initialState from './initialState';

export default function facilitiesReducer(state = initialState.facilities, action) {
    switch (action.type) {
        case LOAD_FACILITIES_SUCCESS:
            return action.facilities;
        default:
            return state;
    }
}
